module.exports = __webpack_public_path__ + "media/messiah.9c02eb3b.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/messiah.mp3
 ** module id = 562
 ** module chunks = 0
 **/